// POI Type models for Settings
export interface PoiType {
  id: number;
  name: string;
  icon: string;
}

export interface PoiTypeGroup {
  id: number;
  name: string;
  poiTypes: PoiType[];
}

// Language/Culture models
export interface AvailableCulture {
  code: string;
  resxName: string;
}

// Site settings from middleware
export interface NavisSiteSettings {
  defect1PoiTypeId: number;
  defect2PoiTypeId: number;
  defect3PoiTypeId: number;
  outdoorDefectPoiTypeId: number;
  fmsBuildingPoiTypeId: number;
  fmsFunctionalAreaPoiTypeId: number;
  deviceRevisionPoiTypeId: number;
  defaultManager: SitePerson;
  defaultCoordinator: SitePerson;
}

export interface SitePerson {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  personalNumber: string;
}

export interface NavvisSiteInfo {
  id: number;
  navvisSiteId: number;
  fmsCampusId: number;
  settings: NavisSiteSettings;
}

export interface UserInfo {
  employee: Employee;
  roles: string[];
}

export interface Employee {
  personalNumber: string;
  name: string;
  surname: string;
  fullName: string;
  email: string;
  phone: string;
}

export interface MiddlewareWebSettings {
  navvisBackendUrl: string;
  navvisSitesInfo: NavvisSiteInfo[];
  defaultTranslations: Record<string, string>;
  availableCultures: AvailableCulture[];
  userPersonalNumber: string;
  userInfo: UserInfo;
}

// User roles
export enum UserRole {
  User = 'User',
  Manager = 'Manager',
  Dispatcher = 'Dispatcher',
  Coordinator = 'Coordinator',
  Administrator = 'Admin',
}
